/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { color, pxToEm, centerAbsolutely, imageTypes, animations, mediaQuery, backgrounds, spacing, heights } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// LOADING STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    loading: {
        // animate in
        zIndex: 1,
        opacity: '0',
        animationName: 'fadeIn',
        animationDelay: '.1s',
        animationDuration: '.3s',
        animationFillMode: 'forwards',
    	extend: centerAbsolutely,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        '& .loader': {
            '& .loader': {
                marginBottom: pxToEm(15)
            }
        }
    }
};
